// import { useEffect, useRef } from "react"; // Unused
// import { useLocalStorage } from "usehooks-ts"; // Unused

// import type PartySocket from "partysocket"; // Unused
// import { useFeatureFlag } from "../../../../hooks/useFeatureFlag"; // Unused
import { CloseTabButton } from "../../../CloseTabButton";
import { AiHelpBrowser } from "../../../Help/AiHelpBrowser";
// import { LiveGuidance } from "../../../LiveGuidance/LiveGuidance"; // Disabled
import { QuestionDisplay } from "../../../Questions/QuestionDisplay";
import { CallResultsReport } from "../../../Report/CallResultsReport";
import { PlaybookScriptDisplay } from "../../../Script/PlaybookScriptDisplay";
import { TranscriptTable } from "../../../Transcript/TranscriptTable";
import { useCallContext } from "../../CallContext";
import { ParticipantManagement } from "../../ParticipantManagement";
import { WaitingForBot } from "../../WaitingForBot";

export const CallMainContent = () => {
  const { roomBot, activeMode } = useCallContext();
  const hasJoinedCall = roomBot?.status_changes?.some(
    (status) => status.code === "in_call_recording",
  );
  // LiveGuidance is fully disabled - always use classic script interface
  // const hasRealtimeFlag = useFeatureFlag("realtime-api");
  // const [useRealtimeAPI] = useLocalStorage("use-realtime-api", false);
  // const usingOpenAIRealtimeMode = hasRealtimeFlag && useRealtimeAPI;

  return (
    <div className="flex-grow overflow-y-auto">
      <div className="flex h-full flex-col">
        <div
          className={`${
            activeMode === "script" ? "block" : "hidden"
          } flex min-h-0 flex-1 flex-grow flex-col`}
        >
          <div className="min-h-0 flex-1">
            <PlaybookScriptDisplay />
          </div>
          <div className="min-h-0 flex-1 flex-grow">
            {hasJoinedCall ? <QuestionDisplay /> : <WaitingForBot />}
          </div>
        </div>
        <div className={`${activeMode === "ai" ? "block" : "hidden"}`}>
          <AiHelpBrowser />
        </div>

        <div
          className={`${activeMode === "participants" ? "block" : "hidden"}`}
        >
          <ParticipantManagement />
        </div>

        <div
          className={`${
            activeMode === "transcript" ? "block" : "hidden"
          } flex h-full flex-grow flex-col`}
        >
          <TranscriptTable />
        </div>
        <div
          className={`${activeMode === "report" ? "block" : "hidden"} relative`}
        >
          <div className="absolute right-2 top-2">
            <CloseTabButton />
          </div>
          <div className="flex h-full flex-col space-y-8">
            <div className="pb-8">
              {activeMode === "report" && <CallResultsReport />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
